module.exports = __webpack_public_path__ + "static/campaign-logo-horiz-with-tag-white-dd0e7c1138f4ba78bb3cfe4370bcbe19.svg";